import { Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export enum BookingOrderDetailsOrderType {
  Standard = 'standard',
  OpenClass = 'openClass',
}

type BookingOrderTypeSelectProps = {
  disabled?: boolean;
  onChange: (orderType: BookingOrderDetailsOrderType) => void;
  value: BookingOrderDetailsOrderType;
};

const BookingOrderTypeSelect: React.FC<BookingOrderTypeSelectProps> = ({
  disabled,
  onChange,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <Select<BookingOrderDetailsOrderType>
      className="w-64"
      disabled={disabled}
      options={[
        {
          label: t('views.BookingOrderDetails.standardOrder'),
          value: BookingOrderDetailsOrderType.Standard,
        },
        {
          label: t('views.BookingOrderDetails.openClassOrder'),
          value: BookingOrderDetailsOrderType.OpenClass,
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
};

export default BookingOrderTypeSelect;
